import { ApiClientError, DeviceTerminal } from '@raydiant/api-client-js';
import { keys } from '../queryClient';
import useProtectedQuery from './useProtectedQuery';
import raydiant from '../clients/miraClient';
import { QueryObserverOptions } from 'react-query';
import { useState } from 'react';

export default function useDeviceTerminal(
  deviceId: string,
  options?: { refetchInterval?: QueryObserverOptions['refetchInterval'] },
) {
  const [refetchInterval, setRefetchInterval] = useState(
    options?.refetchInterval,
  );

  return useProtectedQuery<DeviceTerminal, ApiClientError>(
    keys.deviceTerminal(deviceId),
    async () => {
      const response = await raydiant.getDeviceTerminal(deviceId);

      setRefetchInterval(false);
      return response;
    },
    {
      refetchInterval,
    },
  );
}
